import { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { User } from '../../classess/user/user';
import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { UserCompany } from '../../classess/userCompany/userCompany';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';

import {
    handleResponseMessageAsync, getProcessButtons, isUndNull, isUndNullEmp, getLanguageObj, getResponse, settings,
    styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { UserService } from '../../services/users/UserService';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'UserCompanyAdd';

export default function UserCompanyAdd({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModalUserCompanies: false,
        showModalUserCompanyCustomer: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtUserCompaniesId: '',
        dtUserCompaniesRowId: 0,
        dtUserCompaniesProcess: {
            addCustomer: '',
            delete: '',
            details: '',
        },
        companies: [Company?.getClass({}, false)],
        customers: [Customer?.getClass({}, false)],
        user: User?.getClass({}, false),
        userCompany: UserCompany?.class({}, false),
        userCompanyCustomer: UserCompanyCustomer?.getClass({}, false),
        userCompanyCustomers: [UserCompanyCustomer?.getClass({}, false)],
    },
    setModalObj = {},
    // userCompanies = [UserCompany?.class({}, false)],
    setUserCompanies = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [errors, setErrors] = useState({ userCompany: '' });
    const [process, setProcess] = useState({ save: false, });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBackModal',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSaveModal',
            },
            closeModal: {
                defaultClass: 'close text-secondary',
                id: 'btnModalCloseModal',
            },
        },
        icons: {
            save: {
                id: 'iconSaveModal',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBackModal',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
        },
        selects: {
            userCompany: {
                id: 'selUserCompanyModal'
            },
        },
        spiners: {
            save: {
                id: 'spSaveModal',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    const addUserCompany = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addUserCompany';
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, }));

            response = await UserService.addCompanyAssignmentAsync({
                auth: modalObj?.auth,
                data: modalObj?.userCompany,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const userCompanyData = UserCompany?.class(response?.result?.userCompany || {}, false);
            setUserCompanies(prev => [...prev, userCompanyData]);

            //#region datatable (add row)
            const companyData = {
                email: modalObj?.companies.filter(({ id, }) => id === userCompanyData.companyId)[0]?.email || '',
                secundaryId: modalObj?.companies.filter(({ id, }) => id === userCompanyData.companyId)[0]?.secundaryId || '',
                name: modalObj?.companies.filter(({ id, }) => id === userCompanyData.companyId)[0]?.name || '',
                customersCount: 0,
            };

            const processButtons = [
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: true,
                    methodName: modalObj.dtUserCompaniesProcess.addCustomer,
                    icon: icons?.fasFa?.plusCircle,
                    label: `${labels?.add?.[modalObj?.languageObj?.id]}`
                },
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: true,
                    methodName: modalObj.dtUserCompaniesProcess.details,
                    icon: icons?.fasFa?.list,
                    label: `${labels?.details[modalObj?.languageObj?.id]}`
                },
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: true,
                    methodName: modalObj.dtUserCompaniesProcess.delete,
                    icon: icons?.fasFa?.trash,
                    label: `${labels?.delete[modalObj?.languageObj?.id]}`
                },
            ];

            modalObj.$(`#${modalObj?.dtUserCompaniesId}`).DataTable().row.add([
                companyData.secundaryId,
                companyData.name,
                companyData.customersCount,
                getProcessButtons({
                    id: userCompanyData.id,
                    description: companyData.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: false,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: false,
                    showEdit: false,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: false,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable (add row)

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;

            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModalUserCompanies: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            if (isUndNullEmp({ data: modalObj?.userCompany, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, userCompany: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNull({ data: modalObj?.userCompany?.companyId, subMethod: currentMethod })?.result ||
                modalObj?.userCompany?.companyId <= 0) {
                setErrors(prev => ({ ...prev, userCompany: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors({ userCompany: '' });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        };
    }, []);
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModalUserCompanies} centered size="">
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='company'
                            src={images?.icons?.company}
                            style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.company?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>
                        <i className={icons?.fasFa?.tim} style={{ fontSize: '1.2rem' }} />
                    </span>
                </button>
            </Modal.Header >
            <form onSubmit={(e) => modalObj?.type === 0 ? addUserCompany({ e: e, subMethod: currentMethod }) : e.preventDefault()}>
                <Modal.Body className='pt-2 pb-4 px-4 bg-white'>
                    <div className='mt-3'>
                        {modalObj?.type !== 2 ?
                            <div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.company?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <select id={controls?.selects?.userCompany.id}
                                                className='custom-select bg-light border-0 shadow-sm'
                                                style={{ borderRadius: '5px' }}
                                                disabled={process?.save}
                                                value={!isUndNullEmp({ data: modalObj?.userCompany, subMethod: controls?.selects?.userCompany.id, })?.result && !isUndNullEmp({ data: modalObj?.userCompany?.companyId, subMethod: controls?.selects?.userCompany.id, })?.result ?
                                                    modalObj?.userCompany?.companyId : ``
                                                }
                                                onChange={(e) => setModalObj(prev => ({ ...prev, userCompany: { ...prev?.userCompany, companyId: parseInt(e?.target?.value), } }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, userCompany: '' }))}
                                                placeholder={labels?.company?.[modalObj?.languageObj?.id]}
                                                title={labels?.company?.[modalObj?.languageObj?.id]}>
                                                <option key={`0`} value={0}>{messages?.selectCompany[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.companies.map((company) => <option key={company.id} value={company.id}>{company.name}</option>)}
                                            </select>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.userCompany)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='text-muted'>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex flex-wrap justify-content-center w-100' style={{ gap: '0.5rem' }}>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true' />
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass}`} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`} /> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal >
    )
}